import Vue from 'vue'
import Vuex from 'vuex'
import invoice from '@/store/invoice'
import api from '@/services/cas'
import homeApi from '@/services/home'
//import { head } from '../../server/routes/mod';
import groupHead from '@/store/groupHead'
import ledgerFilter from '@/store/ledgerFilter'
import company from '@/store/company'
import login from '@/store/login'
import signup from '@/store/signup'
import bookseries from '@/store/bookseries'
import party from '@/store/party'
import axios from 'axios'
import api1 from '@/services/api'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    invoice,
    groupHead,
    ledgerFilter,
    company,
    login,
    signup,
    bookseries,
    party
  },

  state: {
    printDialog: false,
    partyDialog: false,
    partyMode: false,
    company: null,
    code:null,
    head:[],
  },
  mutations: {
    printDialog(state) {
      state.printDialog = !state.printDialog
     },
     partyDialog(state) {
       state.partyDialog = !state.partyDialog
       state.partyMode = false
     },
     partyMode(state,mode) {
       state.partyMode = mode
     },
     company(state, cmp) {
       state.company=cmp
       state.company.code = Number (cmp.gstin.substring(0,2))
       //console.log(state.company)
     },
     head(state, head) {
       state.head =head
     }
  },
  actions: {
    printDialog(context, data) {
      context.commit('printDialog')
    },
    partyDialog(context) {
      context.commit('partyDialog')
    },
    partyMode(context, mode) {
      context.commit('partyMode', mode)
    },
    async company(context) {
      // try {
      //   var cmp = await api1.get(api.baseUrl + 'company')
      //   cmp = await cmp.data
      //   console.log(cmp)
      //   context.commit('company', cmp)
      // }
      // catch(err){
      //   console.log(err)

      // }
      try {
        var cmp = await(api.fetchCompany())
        cmp= await cmp.data
        console.log(cmp)
        context.commit('company', cmp)
      } catch (err){
        console.log(err)
        //context.commit('company', 'NO COMPANY SELECTED')
      }

    },
    async fetchHead(context){
      var head =await(homeApi.fetchHead())
     // head = await head.data
      context.commit('head', head)
    }
  },
  getters: {
     
  }

})
